import { NetworkCoverageMapDataContext } from '@app/projects/network-assessment/maps/network-coverage-map/contexts/NetworkCoverageMapDataContext';
import { ProviderAccordionSelectedTab } from '@app/projects/network-assessment/maps/network-coverage-map/enumerators';
import { QESButton } from '@app/shared/qes-standards/Button';
import { QESSelect } from '@app/shared/qes-standards/forms/Select';
import { JSX, useContext } from 'react';


const ProviderAccordionPaging = ({ accordionContainer }: { accordionContainer: React.RefObject<HTMLDivElement> }): JSX.Element => {
  const mapDataContext = useContext(NetworkCoverageMapDataContext);

  const providerPage = () => {
    return mapDataContext.providerAccordionSelectedTab === ProviderAccordionSelectedTab.OutOfNetworkProviders
      ? mapDataContext.impactProvidersPage
      : mapDataContext.networkProvidersPage
  };

  const totalProviderPages = () => {
    return mapDataContext.providerAccordionSelectedTab === ProviderAccordionSelectedTab.OutOfNetworkProviders
      ? mapDataContext.totalImpactPages
      : mapDataContext.totalNetworkPages;
  };

  const incrementProviderPage = (increment: number) => {
    const page = providerPage() + increment;

    mapDataContext.providerAccordionSelectedTab === ProviderAccordionSelectedTab.OutOfNetworkProviders
      ? mapDataContext.setImpactProvidersPage(page)
      : mapDataContext.setNetworkProvidersPage(page);

    accordionContainer.current.scrollTo({
      behavior: 'smooth',
      top: 0
    });
  };

  const changePageSize = (pageSize: number) => {
    if (mapDataContext.providerAccordionSelectedTab === ProviderAccordionSelectedTab.OutOfNetworkProviders) {
      mapDataContext.setImpactPageSize(pageSize);
      mapDataContext.setImpactProvidersPage(1);
    }
    else {
      mapDataContext.setNetworkPageSize(pageSize);
      mapDataContext.setNetworkProvidersPage(1);
    }
  }

  const pageSize = () => {
    return mapDataContext.providerAccordionSelectedTab === ProviderAccordionSelectedTab.OutOfNetworkProviders
      ? mapDataContext.impactPageSize
      : mapDataContext.networkPageSize;
  }

  return (
    <div className="network-coverage-map__provider-accordion-pagination">
      <div className="d-flex justify-content-between align-items-center mt-2">
        <QESButton
          qesType="secondary"
          disabled={providerPage() <= 1}
          onClick={() => incrementProviderPage(-1)}
          qesTestId="network-coverage-map__provider-accordion-providers-prev-page-button"
        >
          Previous
        </QESButton>
        <span className="network-coverage-map__page-of">Page {providerPage()} of {totalProviderPages()}</span>
        <QESButton
          qesType="secondary"
          disabled={providerPage() >= totalProviderPages()}
          onClick={() => incrementProviderPage(1)}
          qesTestId="network-coverage-map__provider-accordion-providers-next-page-button"
        >
          Next
        </QESButton>
      </div>
      <div className="mt-0 d-flex justify-content-center">
        <div className="mt-0 d-flex align-items-center">
          <div className="qes-select__label">Page Size</div>
          <QESSelect
            id="page-size-select"
            label="Page Size"
            hideLabel={true}
            value={pageSize()}
            containerClassName="d-flex flex-row align-items-center qes-select__label-padding-left"
            onChange={e => { changePageSize(Number(e.target.value)) }}
            testId="network-coverage-map__providers-page-size-select"
          >
            {mapDataContext.availablePageSizes.map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </QESSelect>
        </div>
      </div>
    </div>
  );
};

export { ProviderAccordionPaging };